import { gql } from "@apollo/client";

export const CHANGE_FRAGMENT = gql`
  fragment Change on FieldChanges {
    ... on BooleanFieldChange {
      restoreValueBoolean: restoreValue
      currentValueBoolean: currentValue
    }
    ... on StringFieldChange {
      restoreValueString: restoreValue
      currentValueString: currentValue
    }
    ... on StringArrayFieldChange {
      restoreValueStringArray: restoreValue
      currentValueStringArray: currentValue
    }
  }
`;

export const COLLECTION_CHANGE_DATA_FRAGMENT = gql`
  fragment CollectionFieldChangeData on CollectionFieldChangeData {
    ... on CollectionFieldChangedAddedData {
      childId
      status
    }
    ... on CollectionFieldChangedRemovedData {
      parentId
      status
    }
    ... on CollectionFieldChangedReorderedData {
      parentId
      childId
      status
    }
  }
`;

export const GUIDE_PROPAGATION_FIELD_CHANGE = gql`
  fragment GuidePropagationFieldChange on GuidePropagationFieldChange {
    field
    change {
      ...Change
    }
  }

  ${CHANGE_FRAGMENT}
`;

export const GUIDE_COLLECTION_PROPAGATION_FIELD_CHANGE = gql`
  fragment GuideCollectionPropagationFieldChange on GuideCollectionPropagationFieldChange {
    type
    data {
      ...CollectionFieldChangeData
    }
  }

  ${COLLECTION_CHANGE_DATA_FRAGMENT}
`;

export const STAGE_PROPAGATION_FIELD_CHANGE = gql`
  fragment StagePropagationFieldChange on StagePropagationFieldChange {
    field
    change {
      ...Change
    }
  }

  ${CHANGE_FRAGMENT}
`;
